export default [
    {
        "id": "header-1",
        "plugin": "HeaderMenu",
        "pluginId": 5,
        "name": "header",
        "showOptions": true,
        "config": `{"Type":1,"Keys":[],"MaxDepth":0,"Levels":3}`,
        "relatedBanner": "top",
        "html": require('./headers/header-1/html').default,
        "css": require('./headers/header-1/css').default,
        "cssTablet": require('./headers/header-1/cssTablet').default,
        "cssMobile": require('./headers/header-1/cssMobile').default,
        "scss": require('./headers/header-1/scss').default,
        "scssTablet": require('./headers/header-1/scssTablet').default,
        "scssMobile": require('./headers/header-1/scssMobile').default,
		"js": require('./headers/header-1/js').default,
        "minJs": require('./headers/header-1/minJs').default,
        "svgContent": require('./headers/header-1/svgContent').default,
        "svgViewBox": "0 0 1440 220",
        "svgContentMobile": require('./headers/header-1/svgContentMobile').default,
        "svgViewBoxMobile": "0 0 360 160"
    }
]